export default __webpack_public_path__ + "static/media/24_tag_paid-coin-laundry.9932a8a5.svg";